import { useEffect, useState } from 'react';
import { authenticateApp } from './authApp';

export const useAuthApp = (appUsername: string, appPassword: string) => {
  const [authInfo, setAuthInfo] = useState<{
    appToken: string;
    isServiceActive: boolean;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    (async () => {
      try {
        const result = await authenticateApp(appUsername, appPassword);
        setAuthInfo(result);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setLoading(false);
        setError(e);
      }
    })();

    return () => {
      cancel = true;
      setLoading(false);
    };
  }, [appPassword, appUsername]);

  return { authInfo, loadingAuthApp: loading, error };
};
